import axiosClient from "../../../../axiosClient"

const service = async () => {
    const result = await axiosClient.get("/icover-credentials-status")

    return result.data
}

export default service
